import React from "react";
import { Modal } from "@mui/material";
import { WarningAmberOutlined } from "@mui/icons-material";
import styles from "./index.module.scss";

const IncompleteDataModal = ({
	isOpen,
	onClose,
	title = "Incomplete Data",
    heading = "Almost There!",
	description = "A few required fields need to be completed before you can access Loan Pricing. Look for fields highlighted in red — those are the ones that need your attention.",
	sectionsIntro = "Complete the following section(s) to continue:",
	sections = [],
}) => {
	return (
		<Modal
			open={isOpen}
			aria-labelledby="incomplete data modal"
			disableAutoFocus={true}
			disableEscapeKeyDown={true}
			onClose={onClose}
		>
			<div className={styles.dialog}>
				<div className={styles.header}>
					<WarningAmberOutlined className={styles.headerIcon}/>
					<span className={styles.headerText}>{title}</span>
				</div>

				<div className={styles.body}>
                    {heading && <p className={styles.heading}>{heading}</p>}
					{description && <p className={styles.description}>{description}</p>}
					{(sectionsIntro || sections?.length > 0) && (
						<div className={styles.sectionsBlock}>
							{sectionsIntro && (
								<p className={styles.sectionsIntro}>{sectionsIntro}</p>
							)}
							{sections?.length > 0 && (
								<ul className={styles.sectionList}>
									{sections.map((section) => (
										<li key={section} className={styles.sectionItem}>
											{section}
										</li>
									))}
								</ul>
							)}
						</div>
					)}
				</div>

				<div className={styles.footer}>
					<button className={styles.btnOk} onClick={onClose}>
						OK
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default IncompleteDataModal;
